import React, { useEffect, useState } from "react";
import { DialogActions, Typography } from "@material-ui/core";
import { useFormikContext } from "formik";
import { TabPanel, TabView } from "primereact/tabview";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Badge, Card, Table } from "react-bootstrap";
import { Editor } from "primereact/editor";
import DialogLayout from "../../../../partials/content/DialogLayout";
import {
  FormDateField,
  FormSelectField,
  FormTextField,
} from "../../../../partials/content/Forms/FormField";
import { getGlAccounts } from "../../../../services/setup/finance/financeSetupService";
import SearchVendor from "../../inventory/vendors/searchVendor";
import SearchCurrency from "../../setup/finance/searchCurrency";
import SearchOutPaymentDocRef from "./searchOutPaymentDocRef";
import { getIncomingInvoiceDetail } from "../../../../services/finance/incomingInvoice";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import SearchVendorBankAccount from "../../inventory/vendors/vendorDetail/SearchVendorBankAccount";
import SearchOperation from "../../inventory/operations/searchOperation";

function OutgoingPaymentContent({ showBottomSubmit = false }) {
  const [openSearchInvoice, setOpenSearchInvoice] = useState(false);
  const [openSearchVendor, setOpenSearchVendor] = useState(false);
  const [openSearchOperation, setOpenSearchOperation] = useState(false);
  const [expanseAccounts, setExpanseAccounts] = useState([]);
  const [cashAccounts, setCashAccounts] = useState([]);
  const [openSearchCurrency, setOpenSearchCurrency] = useState(false);
  const [incomingInvoice, setIncomingInvoice] = useState({
    incomingInvoiceItem: [],
  });
  const [activeIndex, setActiveIndex] = useState(0);
  const [openSearchBankVendor, setOpenSearchBankVendor] = useState(false);
  const { values, setFieldValue } = useFormikContext();
  useEffect(() => {
    getGlAccountsData();
  }, []);
  return (
    <React.Fragment>
      <div className="tabview">
        <div className="card">
          <TabView className="tabview" scrollable>
            <TabPanel header="A/P Payment Main" rightIcon="fas fa-th-large">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-window-maximize"></i>
                      <span>
                        <strong>Account Payable Payment Header</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <div className="row">
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormSelectField
                                name="docRef"
                                label="Document Reference"
                                options={[
                                  {
                                    value: "1",
                                    label: "Account Payable Invoice",
                                  },
                                  { value: "2", label: "None" },
                                ]}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              {values.docRef === "1" ? (
                                <FormTextField
                                  name="incomingInvoiceCode"
                                  label="A/P Invoice ID"
                                  searchButton
                                  readonly
                                  onSearchClick={() => {
                                    setOpenSearchInvoice(true);
                                  }}
                                />
                              ) : (
                                <FormSelectField
                                  name="expenseAccountID"
                                  label="Expense Account"
                                  options={expanseAccounts}
                                />
                              )}
                            </div>
                          </div>
                          <FormTextField
                            label="Operation"
                            name="operationCardName"
                            searchButton
                            onSearchClick={() => {
                              setOpenSearchOperation(true);
                            }}
                            readonly
                          />
                          <FormTextField
                            name="vendorName"
                            label="Vendor Name"
                            searchButton={values.docRef === "2" ? true : false}
                            readonly
                            onSearchClick={() => {
                              setOpenSearchVendor(true);
                            }}
                          />
                          {values.vendorID > 0 ? (
                            <FormTextField
                              label="Vendor Bank Account"
                              name="vendBankAccountDesc"
                              searchButton
                              clearButton
                              readonly
                              onSearchClick={() => {
                                setOpenSearchBankVendor(true);
                              }}
                              onClearFields={() => {
                                setFieldValue("vendBankAccountID", 0);
                                setFieldValue("vendBankAccountDesc", "");
                              }}
                            />
                          ) : (
                            <FormTextField
                              label="Vendor Bank Account"
                              name="vendBankAccountDesc"
                              readonly
                            />
                          )}
                          <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                name="currencyCode"
                                label="Currency"
                                readonly
                                searchButton={
                                  values.docRef === "2" ? true : false
                                }
                                onSearchClick={() => {
                                  setOpenSearchCurrency(true);
                                }}
                              />
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-6">
                              <FormTextField
                                label="Exchange Rate To Base Currency"
                                name="exchangeRate"
                                currencyField
                                fullDecimals={true}
                                readonly
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 col-md-6 col-lg-6">
                          <FormSelectField
                            name="cashAccountID"
                            label="Cash Account"
                            options={cashAccounts}
                          />
                          <FormDateField
                            name="paymentDate"
                            label="Payment Date"
                          />
                          {values.docRef === "1" ? (
                            <div className="row">
                              <div className="col-sm-6 col-md-6 col-lg-6">
                                <FormTextField
                                  label="A/P Invoice Amount"
                                  name="invoiceAmount"
                                  currencyField
                                  readonly
                                />
                              </div>
                              <div className="col-sm-6 col-md-6 col-lg-6">
                                <FormTextField
                                  label="Unpaid Amount"
                                  name="unpaidAmount"
                                  currencyField
                                  readonly
                                />
                              </div>
                            </div>
                          ) : null}
                          <FormTextField
                            label="Payment Amount"
                            name="paymentAmount"
                            currencyField
                          />
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              </div>
              {values.docRef === "1" &&
              incomingInvoice.incomingInvoiceItem.length > 0 ? (
                <div className="accordion mt-3">
                  <div className="card">
                    <Accordion
                      className="accordion"
                      activeIndex={activeIndex}
                      onTabChange={(e) => setActiveIndex(e.index)}
                    >
                      <AccordionTab
                        header={
                          <React.Fragment>
                            <i className="fas fa-puzzle-piece"></i>
                            <span>
                              <strong>3-Ways Matching Items</strong>
                            </span>
                          </React.Fragment>
                        }
                      >
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-12">
                            <div className="row mb-3">
                              <div className="col-sm-12 col-md-12 col-lg-12">
                                <div className="card">
                                  <Table
                                    striped
                                    borderless
                                    size="sm"
                                    responsive="xl"
                                  >
                                    <thead>
                                      <tr>
                                        <th>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Item Name
                                          </Typography>
                                        </th>
                                        <th>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Ordered Quantity
                                          </Typography>
                                        </th>
                                        <th>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Received Quantity
                                          </Typography>
                                        </th>
                                        <th>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Invoiced Quantity
                                          </Typography>
                                        </th>
                                        <th>
                                          <Typography className="mx-1 kt-font-bolder">
                                            Unit
                                          </Typography>
                                        </th>
                                        <th>
                                          <Typography className="mx-1 kt-font-bolder">
                                            3-Ways Matching Status
                                          </Typography>
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {incomingInvoice.incomingInvoiceItem.map(
                                        (item, index) => (
                                          <tr
                                            key={index}
                                            className="border-top"
                                          >
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.itemType > 0 ? (
                                                  <span>
                                                    <BootstrapTooltip
                                                      title={item.itemTypeName}
                                                    >
                                                      <span className="mr-2">
                                                        <i
                                                          className={
                                                            item.itemType === 1
                                                              ? "fas fa-boxes text-success"
                                                              : item.itemType ===
                                                                2
                                                              ? "fas fa-tools text-primary"
                                                              : item.itemType ===
                                                                3
                                                              ? "fas fa-building text-info"
                                                              : item.itemType ===
                                                                4
                                                              ? "fas fa-boxes text-warning"
                                                              : item.itemType ===
                                                                5
                                                              ? "fas fa-boxes text-danger"
                                                              : null
                                                          }
                                                        ></i>
                                                      </span>
                                                    </BootstrapTooltip>
                                                    <span>
                                                      {item.itemCode}{" "}
                                                      {item.itemName}
                                                    </span>
                                                  </span>
                                                ) : (
                                                  <React.Fragment>
                                                    {item.itemCode}{" "}
                                                    {item.itemName}
                                                  </React.Fragment>
                                                )}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.qtyOrdered}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.qtyReceived}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.qty}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography className="mx-1 my-1">
                                                {item.uom.uomName}
                                              </Typography>
                                            </td>
                                            <td>
                                              <Typography align="center">
                                                <Badge
                                                  className="mx-1 my-1"
                                                  variant={
                                                    item.matchStatus === 1
                                                      ? "danger"
                                                      : item.matchStatus === 2
                                                      ? "success"
                                                      : null
                                                  }
                                                >
                                                  {item.matchStatus !== 0
                                                    ? item.matchStatusDesc
                                                    : null}
                                                </Badge>
                                              </Typography>
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </Table>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </AccordionTab>
                    </Accordion>
                  </div>
                </div>
              ) : null}
            </TabPanel>
            <TabPanel header="Note" rightIcon="fas fa-sticky-note">
              <div className="row">
                <div className="col-sm-12 col-md-12 col-lg-12">
                  <Card>
                    <Card.Header>
                      <i className="fas fa-sticky-note"></i>
                      <span>
                        <strong>Note</strong>
                      </span>
                    </Card.Header>
                    <Card.Body>
                      <Editor
                        style={{ height: "200px", width: "100%" }}
                        onTextChange={(e) => {
                          setFieldValue("note", e.htmlValue);
                        }}
                        value={values.note}
                        placeholder="Type your notes here..."
                      />
                    </Card.Body>
                  </Card>
                </div>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
      <DialogLayout
        open={openSearchInvoice}
        title="Search Incoming Invoice"
        onCloseDialog={() => {
          setOpenSearchInvoice(false);
        }}
        fullScreen={false}
      >
        <SearchOutPaymentDocRef
          onSelectInvoice={(invoice) => {
            setFieldValue("incomingInvoiceID", invoice.ID);
            setFieldValue("incomingInvoiceCode", invoice.incomingInvoiceCode);
            setFieldValue("vendorID", invoice.vendorID);
            setFieldValue("vendorName", invoice.vendor.vendorName);
            setFieldValue("vendBankAccountID", invoice.vendBankAccountID);
            setFieldValue("vendBankAccountDesc", invoice.vendBankAccountDesc);
            setFieldValue("currencyID", invoice.currencyID);
            setFieldValue("currencyCode", invoice.currency.currencyCode);
            setFieldValue("invoiceAmount", invoice.grandTotal);
            setFieldValue("paymentAmount", invoice.unpaidAmount);
            setFieldValue("unpaidAmount", invoice.unpaidAmount);

            getIncomingInvoiceDetail(invoice.ID).then((response) => {
              const { data } = response.data;
              setIncomingInvoice(data.incomingInvoice);
              setOpenSearchInvoice(false);
            });
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchInvoice(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchCurrency}
        title="Search Currency"
        onCloseDialog={() => {
          setOpenSearchCurrency(false);
        }}
        maxWIdth="sm"
      >
        <SearchCurrency
          onSelectCurrency={(currency) => {
            setFieldValue("currencyID", currency.ID);
            setFieldValue("currencyCode", currency.currencyCode);
            setFieldValue("exchangeRate", currency.exchangeRate);
            setOpenSearchCurrency(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchCurrency(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchVendor}
        title="Search Vendor"
        onCloseDialog={() => {
          setOpenSearchVendor(false);
        }}
        maxWIdth="md"
      >
        <SearchVendor
          onSelectVendor={(vendor) => {
            setFieldValue("vendorID", vendor.ID);
            setFieldValue("vendorName", vendor.vendorName);
            setOpenSearchVendor(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchVendor(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchBankVendor}
        title="Search Vendor Bank Account"
        onCloseDialog={() => {
          setOpenSearchBankVendor(false);
        }}
        maxWIdth="lg"
      >
        {values.vendorID > 0 ? (
          <SearchVendorBankAccount
            vendorID={values.vendorID}
            onSelectBankAccount={(bank) => {
              setFieldValue("vendBankAccountID", bank.ID);
              setFieldValue(
                "vendBankAccountDesc",
                `${bank.accountNo} / ${bank.accountHolder} / ${bank.bankName} / ${bank.bankBranch} / ${bank.bankCode}`
              );
              setOpenSearchBankVendor(false);
            }}
          />
        ) : null}
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchBankVendor(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
      <DialogLayout
        open={openSearchOperation}
        title="Search Operation"
        onCloseDialog={() => {
          setOpenSearchOperation(false);
        }}
        maxWIdth="md"
      >
        <SearchOperation
          onSelectOperation={(operation) => {
            setFieldValue("operationCardID", operation.ID);
            setFieldValue("operationCardName", operation.title);
            setOpenSearchOperation(false);
          }}
        />
        <DialogActions>
          <button
            type="button"
            className="btn btn-label-danger btn-md btn-pill btn-bold"
            onClick={() => {
              setOpenSearchOperation(false);
            }}
          >
            <i className="fas fa-window-close"></i>
            Close
          </button>
        </DialogActions>
      </DialogLayout>
    </React.Fragment>
  );
  async function getGlAccountsData() {
    let response = await getGlAccounts("7");
    const { data } = response.data;
    const expanseAccounts = data.glAccounts;
    const expanseAccountList = [];
    for (const account of expanseAccounts) {
      expanseAccountList.push({
        label: account.accountName,
        value: account.ID,
      });
    }
    setExpanseAccounts(expanseAccountList);

    response = await getGlAccounts("1");
    const { data: data2 } = response.data;
    const cashAccounts = data2.glAccounts;
    const cashAccountList = [];
    for (const account of cashAccounts) {
      cashAccountList.push({
        label: account.accountName,
        value: account.ID,
      });
    }
    setCashAccounts(cashAccountList);
  }
}

export default OutgoingPaymentContent;
